











import ECharts from 'vue-echarts'
import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import AddOrEdit from './addOrEditFood.vue'
import {DeletePatPna, GetPatPnas} from "@/api/hd"

@Component({
	components: {AddOrEdit, ECharts}
})
export default class Food extends AbpBase {
	@Prop() patient: any
	addOrEditShow = false
	addOrEditData: any = {}
	loading = false
	tableData = []
	echartsData: any = {}

	mounted(){
		this.clearEchart()
		this.getData()
	}

	columns = [{
		title: '时间',
		width: 200,
		render: (h: any, params: any) => {
			return h('span', this.formatDate(params.row.recordDate))
		}
	}, {
		title: 'SGA',
		width: 200,
		key: 'sga'
	}, {
		title: '实际DPI(g)',
		key: 'sga'
	}, {
		title: '实际DEI(g)',
		key: 'sga'
	}, {
		title: '推荐DPI(g)',
		key: 'sga'
	}, {
		title: '推荐DEI(g)',
		key: 'sga'
	}, {
		width: 180,
		title: '操作',
		render: (h: any, params: any) => {
			return h('div', [
				h('Button', {
					props: {
						type: 'primary'
					},
					style: {
						marginRight: '15px'
					},
					on: {
						click: () => {
							this.editOne(params.row)
						}
					}
				}, '编辑'),
				h('Button', {
					props: {
						type: 'error'
					},
					on: {
						click: () => {
							this.deleteOne(params.row)
						}
					}
				}, '删除'),
			])
		}
	}]

	addOne() {
		this.addOrEditData = {
			mode: 'add',
			patient: this.patient,
		}
		this.addOrEditShow = true
	}

	saveSuccess() {
		this.addOrEditShow = false
		this.getData()
	}

	private async getData() {

	}

	private editOne(row: any) {
		this.addOrEditData = {
			mode: 'edit',
			patient: this.patient,
			item: row
		}
		this.addOrEditShow = true
	}

	private async deleteOne(row: any) {
		this.$confirm('将删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			// todo
			this.getData()
		}).catch(() => {

		});

	}

	private clearEchart() {
		this.echartsData = {
			xAxis: {
				type: 'category',
				data: []
			},
			yAxis: {
				type: 'value'
			},
			series: [{
				data: [],
				type: 'line'
			}]
		};
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/patPna/food.vue